<template>
  <div class="card p-4">
    <div class="card-body">
      <div class="form-profile">
        <div class="middle mb-3">
          <vue-dropzone
            id="dropzone_video_1"
            ref="myVueDropzone"
            :use-custom-slot="true"
            :options="dropzoneOptions"
            @vdropzone-file-added="vfileAdded"
          >
            <div class="dropzone-custom-content">
              <i class="display-4 text-muted bx bx-cloud-download"></i>
              <h5>Choisir ou déposer un fichier</h5>
            </div>
          </vue-dropzone>
        </div>
        <div class="bottom">
          <div class="left"></div>
          <div class="right">
            <div @click="addDocuments" class="btn-action-two" style="height: 30px" v-if="loadedPost">
              <p>Ajouter</p>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center">
              <b-spinner variant="primary" style="width: 1.6rem; height: 1.6rem"></b-spinner>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loadedGet">
        <div class="top-title mt-4">
          <i class="mdi mdi-file-multiple-outline bx-sm"></i>
          DOCUMENTS
          <span></span>
        </div>
        <div class="row d-flex justify-content-around mt-4">
          <div class="col-5 mb-4" v-for="(displayDocument, index) in displayDocuments" :key="displayDocument.id">
            <div class="container-doc">
              <a :href="displayDocument.document" target="_blank">
                <div class="image">
                  <i class="bx bxs-file-doc bx-md"></i>
                </div>
                <div class="text">
                  <div class="title">
                    {{ displayDocument.title }}
                  </div>
                  <div class="info">{{ displayDocument.size }} MO - {{ displayDocument.created_at | formatDate }}</div>
                </div>
              </a>

              <div class="buttons">
                <div class="buttons-little-rounded-action">
                  <i class="bx bx-trash-alt" @click="deleteCvtechDocument(displayDocument, index)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="d-flex justify-content-center align-items-center mt-5">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import { APIRequest } from '@/node-sdk'
import moment from 'moment'

export default {
  name: 'document',

  props: {
    baseUrl: {
      type: String,
      required: true,
    },
    documentRoute: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
    entityId: {
      type: String,
      required: true,
    },
  },

  components: {
    vueDropzone: vue2Dropzone,
  },

  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 100,
        maxFilesize: 0.5,
        headers: { 'My-Awesome-Header': 'header value' },
      },
      formDocument: {
        document: null,
        title: null,
        created_at: null,
        size: null,
      },
      initialFormDocument: {
        document: null,
        title: null,
        created_at: null,
        size: null,
      },
      displayDocuments: [],
      addedDocuments: [],
      loadedGet: false,
      loadedPost: true,
    }
  },

  filters: {
    formatDate: function (date) {
      return moment(date).format('D/MM/YYYY')
    },
  },

  async mounted() {
    await this.getDocuments()
  },
  methods: {
    async deleteCvtechDocument(document, index) {
      this.$delete(this.displayDocuments, index)
      await APIRequest.delete(this.baseUrl, this.documentRoute, document.id)
    },

    async getDocuments() {
      this.loadedGet = false
      this.displayDocuments = await APIRequest.get_with_request(
        this.baseUrl,
        this.documentRoute,
        `?${this.entity}=${this.entityId}`,
      )
      this.displayDocuments = this.displayDocuments[0]
      console.log(this.displayDocuments)
      this.loadedGet = true
    },

    getUser() {
      let user_object = localStorage.getItem('user_object')
      return JSON.parse(user_object).uuid
    },

    async addDocuments() {
      this.loadedPost = false
      for (let i = 0; i < this.addedDocuments.length; i++) {
        this.addedDocuments[i]['user'] = this.getUser()
        this.addedDocuments[i][this.entity] = this.entityId
        console.log('route', this.$route.params.id)
        let document = await APIRequest.create(this.baseUrl, this.documentRoute, this.addedDocuments[i])
        this.displayDocuments.push(document)
        console.log('document', document)
      }
      this.addedDocuments = []
      this.$refs.myVueDropzone.removeAllFiles()
      this.loadedPost = true
    },

    async vfileAddedPromise(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()

        reader.onload = (event) => {
          this.formDocument.document = event.target.result
          resolve(reader.result)
        }

        reader.onerror = reject

        reader.readAsDataURL(file)
      })
    },

    async vfileAdded(file) {
      this.formDocument.title = file.name
      let size = file.size / Math.pow(10, 6)
      this.formDocument.size = size.toFixed(1)
      await this.vfileAddedPromise(file)
      console.log(this.formDocument.document)
      this.addedDocuments.push(this.formDocument)
      this.formDocument = this.initialFormDocument
      console.log(this.addedDocuments)
    },
  },
}
</script>

<style scoped></style>
